import { tsr } from "~/utils/client";

export const useOutOfAreaActivationRolesQuery = () => {
  return tsr.outOfAreaActivationRoles.list.useQuery({
    queryKey: ["out-of-area-activation-roles"],
  });
};
